import { jsx as _jsx } from 'react/jsx-runtime.js';
import { useTranslation } from '@stepstone-platform/i18n';
import { FormCheckbox, Text, Base } from '@stepstone-genesis/components';
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux/index.js';
import { rememberMeSelector, toggleRememberMe } from '../../loginSlice.js';
export const RememberMeCheckbox = () => {
    const { t } = useTranslation();
    const checkboxState = useAppSelector(rememberMeSelector);
    const dispatch = useAppDispatch();
    const stayLoggedToggle = () => dispatch(toggleRememberMe());
    return (_jsx(Base, { sx: { input: { margin: 'initial' } }, children: _jsx(FormCheckbox, { "data-testid": "remember-me", checked: checkboxState, onChange: stayLoggedToggle, size: ['medium'], isRequired: true, children: _jsx(Text, { size: ['small', 'medium'], children: t('loginregistration.login.rememberMe') }) }) }));
};
//# sourceMappingURL=RememberMeCheckbox.js.map